import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_PAGE
} from './constants';

export class Page {

  static getPage(pageId = "") {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_PAGE}/getPage?pageId=${pageId}`
    }).catch((err) => {
      throw new Error(err);
    });
  }

}

export default Page;



// WEBPACK FOOTER //
// ./src/api/Page.js